import { getCanonicalAsciiByKey } from './catalog-alias-map';

/** Resolves a raw unit string to a key present in a family's pivot map. */
export type ResolvePivotKey = (rawKey: string) => string | undefined;

/**
 * Maps raw source/target strings to pivot map keys. Direct pivot hits win; otherwise
 * aliases resolve through catalog canonicalAsciiByKey → asciiSymbol.toLowerCase().
 */
export function createResolvePivotKey(
  pivotMap: Record<string, unknown>,
  canonicalAsciiByKey?: Record<string, string>
): ResolvePivotKey {
  return (rawKey: string): string | undefined => {
    const aliasMap = canonicalAsciiByKey ?? getCanonicalAsciiByKey();
    const lower = rawKey.toLowerCase();
    if (Object.hasOwn(pivotMap, lower)) return lower;

    const canonical = aliasMap[lower];
    if (canonical && Object.hasOwn(pivotMap, canonical)) return canonical;

    return undefined;
  };
}
